import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import infineonImage from '../assets/logo.svg';
import { useNavigate } from 'react-router-dom';
//react functional compoenent for the app header
const Header = () => {
    const navigate = useNavigate();
    return (_jsx("div", { className: "header", children: _jsxs("div", { className: "header-container", children: [_jsx("img", { className: "header-img", src: infineonImage, alt: "infenio logo", onClick: (event) => {
                        event.preventDefault();
                        window.open(`https://www.infineon.com`, '_blank');
                    } }), _jsx("div", { className: "header-title", children: _jsx("h4", { className: "header-heading", onClick: (event) => {
                            event.preventDefault();
                            navigate('/');
                        }, children: 'DEEPCRAFT\u2122 AI Hub' }) })] }) }));
};
export default Header;
